module.exports = __webpack_public_path__ + "img/Bear36.476ad5bb.jpg";